module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"first":"« First","last":"Last »","next":"Next ›","prev":"‹ Prev"}}')
  delete Component.options._Ctor
}
